import { Badge, Drawer, Tag } from "antd";
import { DollarOutlined, SearchOutlined } from "@ant-design/icons";
import { DOT_COLOR_AVG } from "../Benchmark";
import { ColorStar } from "../../../../../../common/utils/ColorStar";
import TableLZM from "../../../../../components/design/table/TableLZM";
import { normalize } from "../../../../../../common/utils/TextUtils";

export const CityPlacesDrawer = (props: { city: string, competitor: string, keyword: string, places: any, onFinish: any, allCompetitors: any }) => {                          
    
    const competitorsArray = !Array.isArray(props.allCompetitors) ? props.allCompetitors.replace(/"/g, '').split(',') : props.allCompetitors[0]?.replace(/"/g, '').split(',');
    
    //console.log(">>>>>>>" + props.allCompetitors)
    const SEO_COLUMNS: any = [		
        {
            title: '',
            dataIndex: 'position',
            width: '60px',
            render: (text: string, record: any) => (				
                    <div style={{ backgroundColor: DOT_COLOR_AVG[record.position], color:'white', height: '35px', width: '35px', borderRadius: '50%', border:'solid 2px white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {record.position < 21 ? record.position : <small>{'+20'}</small>}                    
                    </div>
            )	
        },        
        {
            title: 'Nombre',
            dataIndex: 'name',
            width: '200px',
            render: (text: string, record: any) => (	
                <>
                {normalize(record.title).includes(normalize(props.competitor)) ?
                    <Tag style={{color:'blue', borderRadius:'20px'}} color="dodgerblue" ><a href={record.link} target='blank'> {record.title}</a></Tag>
                    :
                    <a href={`https://maps.google.com/?cid=${record.data_cid}`} target='blank'>{competitorsArray.some((marca: string) => record.title.toLowerCase().includes(marca.toLowerCase())) && <Badge color="darkred"/>} {record.title}</a>
                }
                </>			
            )	
        },
        {
            title: 'Reseñas',
            dataIndex: 'rating',
            align: 'center',
            render: (text: string, record: any) => (
                record.rating > 0 && <div style={{color:'grey'}}>
                    <ColorStar style={{ fontSize: '18px' }} value={Math.round(10 * record.rating) / 10}/>
                    {record.reviews > 0 && <small>{record.reviews} reseñas</small>}
                </div>
            )	
        },   
        {
            title: 'Ads',
            dataIndex: 'ads',
            width: '130px',
            render: (text: string, record: any) => (				
                    <div>
                        <small style={{color:'slategrey', fontSize:'22px'}}>{record.sponsored ? <DollarOutlined/> : <>-</>}</small>
                    </div>
            )	
        },                
        {
            title: 'Web',
            dataIndex: 'websiteUri',
            align: 'center',
            render: (text: string, record: any) => (
                <>{record.link && <a href={record.link} target='blank'>Web</a>}</>				
            )	
        }         
    ]

    return (
        <Drawer
            placement="right"
            width={'50%'}
            open={true}
            onClose={props.onFinish}            
            bodyStyle={{ background: '#F4F7FA' }}            
            headerStyle={{ background: '#F4F7FA' }}            
            title={<div style={{display:'flex', justifyContent:'space-between'}}>
                <h2 style={{color:'teal'}}><b>{props.competitor}</b></h2>                
                <h2 style={{color:'slategray'}}><SearchOutlined/> "{props.keyword} en {props.city}"</h2>
            </div>}>   
            <h2 style={{color:'slategray'}}>Top 20</h2>
            <TableLZM
                rowKey='rankPosition'
                size='small'
                //scroll={{ x: true }}
                pagination={{ defaultPageSize: 20 }}
                columns={SEO_COLUMNS}
                dataSource={props.places}
                //loading={isLoading}
            />
        </Drawer>    
    );
};

